import Axios from './axios'

const BASE_URL = '/v3/invoices'
const RCM_BASE_URL = '/v3/RCM'

const RCM_TIMEOUT = 65_000

export const sendClaim = async claimId => {
  const response = await Axios.post(
    `${BASE_URL}/sendClaim`,
    { claim_id: claimId },
    { timeout: RCM_TIMEOUT }
  )
  return response.data
}

export const matchClaimInsurancePlan = async claimId => {
  const response = await Axios.post(
    `${RCM_BASE_URL}/matchClaimInsurancePlan`,
    { claim_id: claimId },
    { timeout: RCM_TIMEOUT }
  )
  return response.data
}
